import {
  GET_RETAILER_SETTINGS_REQUEST,
  GET_RETAILER_SETTINGS_RESPONSE,
  GET_RETAILER_SETTINGS_ERROR,
  SET_RETAILER_SETTINGS_DATA,
} from '../../actions/Admin/adminRetailerSettingsAction';
import { IApiRequest, IRetailerDetails } from '../../types';

const initialState: IApiRequest<IRetailerDetails> = {
  data: null,
  loading: false,
  error: '',
  UpdatedAt: null,
};

const adminRetailerSettingsReducer = (
  state: IApiRequest<IRetailerDetails> = initialState,
  action: any,
): IApiRequest<IRetailerDetails> => {
  switch (action.type) {
    case GET_RETAILER_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case GET_RETAILER_SETTINGS_RESPONSE:
      return {
        ...state,
        data: action.response,
        loading: false,
        error: '',
        UpdatedAt: new Date(),
      };
    case GET_RETAILER_SETTINGS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error || 'Error loading retailer settings',
      };
    case SET_RETAILER_SETTINGS_DATA:
      return {
        ...state,
        data: action.response,
        loading: false,
        error: '',
        UpdatedAt: new Date(),
      };
    default:
      return state;
  }
};

export default adminRetailerSettingsReducer;
